

// Helper function to format price for display
export const formatAmountForDisplay = (
  amount: number,
  currency: string = "USD"
): string => {
  const numberFormat = new Intl.NumberFormat([ "en-US" ], {
    style: "currency",
    currency,
    currencyDisplay: "symbol"
  });
  return numberFormat.format(amount);
};
//
// // Helper function to format price for Stripe
// export const formatAmountForStripe = (
//   amount: number,
//   currency: string = "USD"
// ): number => {
//   const numberFormat = new Intl.NumberFormat([ "en-US" ], {
//     style: "currency",
//     currency,
//     currencyDisplay: "symbol"
//   });
//
//   const parts = numberFormat.formatToParts(amount);
//   let fraction = "";
//
//   for (const part of parts) {
//     if (part.type === "fraction") {
//       fraction = part.value;
//     }
//   }
//
//   return amount * 100;
// };